import { render, staticRenderFns } from "./bottom-adv.vue?vue&type=template&id=8fccf9da&scoped=true"
import script from "./bottom-adv.vue?vue&type=script&lang=js"
export * from "./bottom-adv.vue?vue&type=script&lang=js"
import style0 from "./bottom-adv.vue?vue&type=style&index=0&id=8fccf9da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fccf9da",
  null
  
)

export default component.exports